import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles';
import { useTranslation } from 'react-i18next';

export default function FormFieldError({ error }) {
  const { t } = useTranslation();
  return (error && <div className={styles.error}>{t(error)}</div>) || null;
}

FormFieldError.propTypes = {
  error: PropTypes.string,
};
